var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2102 0.809782C19.5782 0.284948 18.8005 0 17.9998 0C17.1992 0 16.4214 0.284948 15.7895 0.809782L0.698573 13.3393C-0.655 14.4673 0.0901849 16.783 1.80555 16.783H3.60011V32.1566C3.60011 33.1759 3.97939 34.1535 4.65451 34.8743C5.32963 35.5951 6.24528 36 7.20004 36H14.3999V24.4698C14.3999 23.4505 14.7792 22.4729 15.4543 21.7521C16.1294 21.0313 17.0451 20.6264 17.9998 20.6264C18.9546 20.6264 19.8702 21.0313 20.5454 21.7521C21.2205 22.4729 21.5998 23.4505 21.5998 24.4698V36H28.7996C29.7544 36 30.67 35.5951 31.3451 34.8743C32.0203 34.1535 32.3995 33.1759 32.3995 32.1566V16.783H34.1941C35.9077 16.783 36.6564 14.4673 35.3011 13.3412L20.2102 0.809782Z",
    fill: "#76777B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoHome);
export default __webpack_public_path__ + "static/media/mo_home.ba0a9ad098027bff4e21129edc37b792.svg";
export { ForwardRef as ReactComponent };